import { TextField } from '@mui/material';
import { useRef, useEffect } from 'react';

interface NumberEditorProps {
    ruleId: string;
    value: string | number;
    onChange: (value: string) => void;
}

function NumberEditor({ ruleId, value, onChange }: NumberEditorProps) {
    const inputRef = useRef<HTMLInputElement>(null);

    // Mettre à jour la valeur initiale si elle change
    useEffect(() => {
        const strValue = value ? String(value) : '';
        if (inputRef.current && inputRef.current.value !== strValue) {
            inputRef.current.value = strValue;
        }
    }, [value]);

    return (
        <TextField
            inputRef={inputRef}
            type="number"
            size="small"
            fullWidth
            defaultValue={value || ''}
            onBlur={(e) => onChange(e.target.value)}
            placeholder="Entrez un nombre..."
        />
    );
};

export default NumberEditor;
